import {CompanyPayload} from '../util'

export const getPortfolios = () => ({apis}) => {
  const payload = apis.getUserPortfolios(0, 1000).map((x) => x)
  return {
    type: 'GET_PORTFOLIOS',
    payload,
  }
}

export const onMonitoringResultPageChange = (data) => {
  return {
    type: 'MONITORING_RESULT_PAGE_CHANGE',
    data,
  }
}

export const changePortfolio = (data) => {
  return {
    type: 'CHANGE_PORTFOLIO',
    data,
  }
}

export const searchCompanies = (pageNo, pageSize) => ({apis, getState}) => {
  const portfolioId = getState().monitoring.selectedPortfolio
  const params = `page=${pageNo - 1}&pageSize=${pageSize}`
  const payload = apis.searchCompaniesByPortfolio(portfolioId, params).map((x) => x)
  return {
    type: 'GET_COMPANIES',
    payload,
  }
}

export const getEvents = (id) => ({apis}) => {
  const payload = apis.getCompanyEvents(id).map((x) => x)
  return {
    type: 'GET_EVENTS',
    payload,
  }
}

export const addCompany = (id) => ({apis, getState}) => {
  const portfolioId = getState().monitoring.selectedPortfolio
  const data = {...CompanyPayload, id: id}
  const payload = apis.addCompanyToPortfolio(portfolioId)(data).map((x) => x)
  return {
    type: 'ADD_COMPANY',
    payload,
    data,
  }
}

export const deleteCompany = (companyId) => ({apis, getState}) => {
  const portfolioId = getState().monitoring.selectedPortfolio
  const payload = apis.deleteCompanyFromPorfolio(portfolioId, companyId).map((x) => x)
  return {
    type: 'DELETE_COMPANY',
    data: portfolioId,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/store/monitoring/actions.js